<template>
  <div class="setting-content--section">
    <add-payment-notification container="paymentDetails"></add-payment-notification>
  </div>
</template>

<script>
import settingsPageSetup from "@/mixins/settingsPageSetup";
import AddPaymentNotification from "@/components/subscriptions/AddPaymentNotification";

export default {
  name: "PaymentDetails",
  components: {AddPaymentNotification},
  mixins: [settingsPageSetup],
  data() {
    return {
        pageSettings: {
            title: "Payment details",
            showCompanyPicker: false
        },
    }
  },
}
</script>

<style scoped>

</style>